// React
import { Fragment } from "react"

// Components
import { Button, FooterMenu } from "components"
import { Print } from "./Print"

// Form
import { useFormContext, useWatch } from "react-hook-form"

// Types
import type { FormSalesOrderType } from "../../CustomerOrder/types"

type CommandButtonsProps = {
  display?: boolean
  isSubmitting?: boolean
  showSaveButton?: boolean
  onSave?: () => void
}

export const CommandButtons = ({
  display = true,
  isSubmitting,
  showSaveButton,
  onSave
}: CommandButtonsProps) => {
  // Form
  const { control } = useFormContext<FormSalesOrderType>()
  const so_delivery_status = useWatch({
    control,
    name: "so_delivery_status"
  })

  return (
    <div className={display ? "" : "hidden"}>
      <FooterMenu
        hasCancelButton
        customElement={{
          save: (
            <Fragment>
              {showSaveButton && (
                <Button
                  disabled={isSubmitting}
                  className="uppercase flex flex-col h-16 bg-base-200 border-[1px] border-base-300 px-0 w-24 hover:bg-primary hover:text-black border-white"
                  color="ghost"
                  onClick={onSave}>
                  Close Sales
                </Button>
              )}
            </Fragment>
          ),
          print: so_delivery_status === 4 ? <Print /> : undefined
        }}
      />
    </div>
  )
}
